import { render, staticRenderFns } from "./flightOrderInfo.vue?vue&type=template&id=589d51f8&"
import script from "./flightOrderInfo.vue?vue&type=script&lang=ts&"
export * from "./flightOrderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./flightOrderInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports